<ng-template let-data="adtData" let-emitter="captureEvents" #webHookActionCell>
    <app-failed-transactions-action-cell [selectedTransaction]="data"></app-failed-transactions-action-cell>
</ng-template>


<div class="container webhook-details-list">
    <header>
        <div (click)="this.router.navigateByUrl('/integration/web-hook/list')" class="ml-n3 cursor--pointer" style="color: #0076FF;">
            <i class="fas fa-chevron-left mr-2"></i>
            <span class="body-2 cursor--pointer">Webhook list</span>
        </div>
        <div class="d-flex justify-content-between mt-3">  
            <div class="d-flex align-items-center mb-1">
                <h1 class="headline-4 mr-2 mb-0">{{selectedWebHook?.name}}</h1>
            </div>

            <ul class="d-flex flex-row justify-content-end actions-list list-group" style="height: 36px;" >
                <li (click)="onEdit()"
                    class="list-group-item d-flex px-2 mr-2">
                    <i class="fas fa-edit pointer"></i>
                    <span class="ml-2 pointer expanded-text body-1 ">Edit</span>
                </li>
                <li (click)="onDelete()"
                    class="list-group-item d-flex px-2 mr-2">
                    <i class="fas fa-trash pointer"></i>
                    <span class="ml-2 pointer expanded-text body-1 ">Delete</span>
                </li>
                <li (click)="onTestSend()"
                    class="list-group-item d-flex px-2 mr-2">
                    <i class="fas fa-paper-plane pointer"></i>
                    <span class="ml-2 pointer expanded-text body-1 ">Test send</span>
                </li>
            </ul> 
        </div>
        <span class="body-2 d-flex mb-3" style="color: #676767;">Created On {{ selectedWebHook?.created | date: 'MMM d, y'}}</span>
        <span class="mt-3">{{selectedWebHook?.url}}</span>
    </header>

    <mdb-tabs (activeTabChange)="onTabChange($event)" #tabs class="mdb-tabs mdb-tabs--no-padding account-page font-family-settings mt-2">
        <mdb-tab title="Failed transactions" class="position-relative">
            @if(!failedTransactions || failedTransactions.length ===0){
                <div class="text-center p-3">No failed transactions!</div>
            }
            @else{
                <div class="table--paybee" style="width: auto;">
                    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table">
                        <thead class="thead-light">
                            <tr>
                                <th>Event Type</th>
                                <th>Created</th>
                                <th>Error Code</th>
                                <th>Error Message</th>
                                <th>Last Retried</th>
                                <th>Retry Count</th>
                                <th>Amount</th>
                                <th></th>
                            </tr>
                        </thead>
                    </table>
                </div>
            }
        </mdb-tab>
    </mdb-tabs>
</div>